import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  compose,
  lifecycle,
  withProps,
  withHandlers,
  withStateHandlers,
  branch,
  renderComponent
} from 'recompose'
import { Loader } from '@driftt/tide-core-legacy'

import PickOauthComponent from './PickOauthComponent'
import SelectCalendarComponent from './SelectCalendarComponent'

import {
  getIsGoogleOauthConnected,
  getIsMicrosoftOauthConnected,
  getCalendar,
  getCalendars,
  getIsTokenRevoked,
  getCalendarStatusLoaded,
  isGoogleOrMicrosoftConnected
} from 'app/modules/meetings/selectors'

import { fetchCalendarStatus } from 'app/modules/meetings/actions'

function makeMapStateToProps() {
  return state => ({
    calendar: getCalendar(state),
    getCalendarStatusLoaded: getCalendarStatusLoaded(state),
    hasCalendars: getCalendars(state).size > 0,
    googleAuthed: getIsGoogleOauthConnected(state),
    microsoftAuthed: getIsMicrosoftOauthConnected(state),
    isTokenRevoked: getIsTokenRevoked(state),
    isGoogleOrMicrosoftConnected: isGoogleOrMicrosoftConnected(state)
  })
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        fetchCalendarStatus,
      },
      dispatch
    ),
  }
}

export default compose(
  connect(makeMapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.actions.fetchCalendarStatus()
    },
    componentWillReceiveProps(nextProps) {
      const nextPropsHasCalendar = !!(nextProps.calendar && nextProps.calendar.id)
      if (!this.props.calendar.equals(nextProps.calendar) && nextPropsHasCalendar) {
        nextProps.router.replace('/settings/calendar')
      }
    }
  }),
  withHandlers({
    handleSaveRedirect: props => () => {
      props.router.replace('/settings/calendar')
    },
  }),
  withProps(({ googleAuthed, microsoftAuthed, hasCalendars }) => ({
    connected: (googleAuthed || microsoftAuthed) && hasCalendars,
  })),
  withStateHandlers(
    () => ({ googlePermissionError: false }),
    {
      setGooglePermissionErrorState: () => (status) => ({ googlePermissionError: status })
    }
  ),
  branch(({ getCalendarStatusLoaded }) => !getCalendarStatusLoaded, renderComponent(Loader)),
  branch(({ connected }) => connected, renderComponent(SelectCalendarComponent))
)(PickOauthComponent)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/CalendarConnect/index.js